import React, { useEffect } from "react";

import HomeFooter from "../HomePage/HomeFooter";
import FSNavigation from "../FSApp/FSNavigation";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Politika Privatnosti - FucaScore";
  }, []);

  return (
    <>
      <FSNavigation />
      <div className="scorify-app privacy-terms">
        <button className="back-btn" onClick={() => window.history.back()}>
          ⬅ Povratak
        </button>
        <main className="scorify-main">
          <div className="policy-glass-card">
            <h1>Politika Privatnosti</h1>
            <p className="last-updated">Zadnja izmjena: Srpanj 2026.</p>

            <section>
              <h2>1. Uvod i voditelj obrade podataka</h2>
              <p>
                Dobrodošli na <strong>FucaScore</strong>. Ova Politika
                privatnosti objašnjava kako prikupljamo, koristimo i štitimo
                vaše podatke kada koristite našu platformu za praćenje
                malonogometnih turnira, rezultata i statistika. Posvećeni smo
                zaštiti vaše privatnosti i osiguravanju sigurnog okruženja za
                sve korisnike i sudionike.
              </p>
            </section>

            <section>
              <h2>2. Koje podatke prikupljamo?</h2>
              <p>
                Prikupljamo samo minimalne podatke nužne za nesmetano
                funkcioniranje natjecanja i prikaz statistika:
              </p>
              <ul>
                <li>
                  <strong>Podaci o igračima:</strong> Ime i prezime (na
                  platformi se u pravilu prikazuju kao ime i inicijal prezimena
                  radi zaštite privatnosti), pripadnost timu te sportska
                  statistika (golovi, kartoni).
                </li>
                <li>
                  <strong>Podaci o timovima i organizatorima:</strong> Nazivi
                  ekipa, popisi igrača te kontakt podaci organizatora turnira
                  koji koriste platformu.
                </li>
                <li>
                  <strong>Tehnički podaci:</strong> Osnovni logovi poslužitelja
                  i tehnički nužni kolačići za rad administratorskog sučelja.
                </li>
              </ul>
            </section>

            <section>
              <h2>3. Svrha i pravna osnova obrade</h2>
              <p>
                Prikupljene podatke obrađujemo isključivo u svrhu organizacije
                sportskih natjecanja, vođenja službenih evidencija i
                informiranja javnosti o rezultatima turnira na temelju
                legitimnog interesa i svrhe pružanja digitalnih usluga u sportu.
              </p>
            </section>

            <section>
              <h2>4. Sigurnost podataka</h2>
              <p>
                Svi podaci uneseni na platformu pohranjeni su unutar sigurne
                baze podataka na infrastrukturi <strong>Supabase</strong>, koja
                koristi moderne standarde enkripcije, sigurnosne protokole i
                kontrolu pristupa kako bi spriječila neovlašteno korištenje ili
                gubitak podataka.
              </p>
            </section>

            <section>
              <h2>5. Vaša prava</h2>
              <p>
                Kao korisnik ili sudionik turnira imate pravo zatražiti uvid u
                svoje podatke, ispravak netočnih podataka ili njihovo brisanje
                (anonimizaciju) slanjem službenog upita timu FucaScore-a ili
                organizatoru turnira.
              </p>
            </section>

            <section>
              <h2>6. Kolačići (Cookies)</h2>
              <p>
                FucaScore koristi isključivo{" "}
                <strong>tehnički nužne kolačiće</strong> i lokalnu pohranu
                preglednika (localStorage) kako bi ovlaštenim osobama
                (administratorima i zapisničarima) omogućili prijavu i rad u
                sustavu. Ne koristimo kolačiće za praćenje korisnika u
                marketinške svrhe.
              </p>
            </section>

            <section>
              <h2>7. Razdoblje pohrane podataka</h2>
              <p>
                Sportska statistika i podaci o završenim turnirima čuvaju se kao
                trajni povijesni zapis rezultata platforme FucaScore.
                Administratori i osoblje turnira zadržavaju pristup sustavu do
                opoziva ovlaštenja.
              </p>
            </section>

            <section>
              <h2>8. Dijeljenje podataka s trećim stranama</h2>
              <p>
                FucaScore ne prodaje, ne iznajmljuje niti ustupa vaše osobne
                podatke trećim stranama. Podaci su vidljivi javnosti samo u
                mjeri u kojoj je to potrebno za praćenje sportskih rezultata
                (tablice, strijelci, rasporedi).
              </p>
            </section>
          </div>
        </main>
      </div>
      <HomeFooter />
    </>
  );
};

export default PrivacyPolicy;
